'use client'
import type { CmsLinksFields } from '@maestro/sanity-cms-blocks/blocks/cms-links/cms-links.types'
import type { PropsWithChildren } from 'react'

import { Link } from '@pearlconvert/ui/components/link'
import { useModalLink } from '@pearlconvert/ui/hooks/use-modal-link'

export default function CmsLink(
  props: Partial<CmsLinksFields> & PropsWithChildren
) {
  const { link, children } = props
  const { url, handleClick } = useModalLink(link)

  return (
    <Link
      href={url}
      target={link?.blank ? '_blank' : undefined}
      onClick={handleClick}
    >
      {children}
    </Link>
  )
}
